module.exports = __webpack_public_path__ + "ClientApp/images/content/lap-of-love-newsletter.jpg";